module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-move-b95fcf37776287c749ab8312c5fab844.png";